import React from 'react';
import PropTypes from 'prop-types';

import {
    Flex, Paragraph, Text,
} from '@zillow/constellation';
import {
    Center, Col, Container, Row,
} from '@zillow/zrs-comet';


import RadioButton from '../../components/RadioButton';

import { StyledHR } from '../StyledComponents';

const ADD_RENT_GUARANTEE_FEE = 'addRentGuaranteeFee';
const SUBTRACT_RENT_GUARANTEE_FEE = 'subtractRentGuaranteeFee';
const RENT_GUARANTEE_FEE = 30;

const propTypes = {
    paymentMethod: PropTypes.string,
    setPaymentMethod: PropTypes.func.isRequired,
    monthlyRent: PropTypes.number,
};
const defaultProps = {
    paymentMethod: null,
    monthlyRent: null,
};

const TwoWaysToPay = ({
    paymentMethod,
    setPaymentMethod,
    monthlyRent,
}) => {
    const rentGuaranteeFeeAdded = Number(monthlyRent) + RENT_GUARANTEE_FEE;
    const rentGuaranteeFeeSubtracted = Number(monthlyRent) + RENT_GUARANTEE_FEE;

    return (
        <Flex display="flex" alignItems="center" flexDirection="column" id="two-ways-to-pay">
            <StyledHR color="yellow300" />
            <Center>
                <Paragraph fontType="h4">
                    Two ways to pay
                </Paragraph>
                <Paragraph marginBottom="sm">
                    Choose how to pay the monthly fee for Rent Guarantee. The
                    payment won’t be due until the tenant makes their first rent payment.
                </Paragraph>
            </Center>
            <Container>
                <Row>
                    <Col xs={6}>
                        <RadioButton
                            onClick={() => setPaymentMethod(ADD_RENT_GUARANTEE_FEE)}
                            name="payment-method"
                            id="add-to-monthly-rent"
                            label={`Monthly rent + $${RENT_GUARANTEE_FEE}`}
                            description={(
                                <>
                                    <Paragraph fontType="bodySmall">
                                        Tenant pays $
                                        {rentGuaranteeFeeAdded}
                                    </Paragraph>
                                    <Paragraph fontType="bodySmall">
                                        You receive $
                                        {monthlyRent}
                                    </Paragraph>
                                </>
                            )}
                            checked={paymentMethod === ADD_RENT_GUARANTEE_FEE}
                            helperText={(
                                <div>
                                    <Text fontType="bodySmallHeading">Add </Text>
                                    <Text fontType="bodySmall">it to the monthly rent tenants pays</Text>
                                    <Paragraph fontType="bodySmall">(They wont&apos; know you added a fee.)</Paragraph>
                                </div>
                            )}
                        />
                    </Col>
                    <Col xs={6}>
                        <RadioButton
                            onClick={() => setPaymentMethod(SUBTRACT_RENT_GUARANTEE_FEE)}
                            name="payment-method"
                            id="subtract-to-monthly-rent"
                            label={`Monthly rent - $${RENT_GUARANTEE_FEE}`}
                            description={(
                                <>
                                    <Paragraph fontType="bodySmall">
                                        Tenant pays $
                                        {monthlyRent}
                                    </Paragraph>
                                    <Paragraph fontType="bodySmall">
                                        You receive $
                                        {rentGuaranteeFeeSubtracted}
                                    </Paragraph>
                                </>
                            )}
                            checked={paymentMethod === SUBTRACT_RENT_GUARANTEE_FEE}
                            helperText={(
                                <div>
                                    <Text fontType="bodySmallHeading">Subtract </Text>
                                    <Text>it from the monthly rent you receive</Text>
                                </div>
                            )}
                        />
                    </Col>
                </Row>
            </Container>
        </Flex>
    );
};

TwoWaysToPay.propTypes = propTypes;
TwoWaysToPay.defaultProps = defaultProps;

export default TwoWaysToPay;
